/**
 * Created by lihib on 16-Nov-14.
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var Media = require("media");
    var Page = require("ui.components/page/Page");
    var LpTagView = require("manager-views/LPTagView");
    var ManageDomainsModel = require("manager-models/ManageDomainsModel");
    var LPTagController = {};
    var EVENT_PREFIX = "LPTag";
    var LEConfig = require("assets/config/le-env-conf");

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        LPTagController = Marionette.Controller.extend({
            vent: null,

            initialize: function(options) {
                this._initialize(options);
            },
            getMainView: function() {
                return this._getMainView();
            },
            showLPTagPage: function() {
                this._showLPTagPage();
            },

            _initialize: function (options) {
                LEManager.logger.debug("Create private vent and bind to events","LPTagController:initialize. options = " + options);
                this.vent = Media.vent();

                this.listenTo(this.vent, EVENT_PREFIX + ":Close", _.bind(this._handleCloseEventXDone, this));
            },

            _getMainView:function () {
                this._initPageComponent();
                return this.LPTagPage;
            },

            _initPageComponent: function(){
                this.LPTagPage = new Page({
                    moduleName:LEManager.moduleName,
                    context:LE.context,
                    view:  null,
                    header: {
                        title: LE.translator.translate("LEFramework.LiveEngageTag.title"),
                        description: LE.translator.translate("LEFramework.LiveEngageTag.description")
                    }
                });
                this.LPTagPage.domain = LEConfig.LPTagDomainsOverrideConfig || '{}';
                this.listenTo(this.LPTagPage, "close", _.bind(this._handleClosePageEventWrapUp, this, this.LPTagPage));
            },

            _showLPTagPage: function() {
                LEManager.showLoader();
                if(LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_REFERER_RESTRICTIONS)) {
                    var manageDomainsModel = new ManageDomainsModel();
                    //Fetch data for know if we need display icon indication "V"
                    manageDomainsModel.fetch({
                        success: _.bind(function () {
                            this._createLpTagView(manageDomainsModel);
                        }, this),
                        error: _.bind(function() {
                            this._createLpTagView(manageDomainsModel);
                        }, this)
                    });
                } else {
                    this._createLpTagView();
                }
            },

            _createLpTagView :function (manageDomainsModel) {
                this.insideView = new LpTagView({
                    vent: this.vent,
                    sessionManager: LE.sessionManager,
                    domain: this.LPTagPage.domain,
                    manageDomainsModel: manageDomainsModel
                });
                this.LPTagPage.setInsideView(this.insideView);
                LEManager.closeLoader();
            },

            _handleCloseEventXDone :function () {
                LEManager.logger.debug("The event was " + EVENT_PREFIX + ":Close","LPTagController:_bind");
                LEManager.router.navigateBack();
            },

            _handleClosePageEventWrapUp: function(closedPageView) {
                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.LPTagPage && closedPageView && closedPageView.cid === this.LPTagPage.cid) {
                    this.LPTagPage = null;
                    this.insideView = null;
                }
            }
        });
    });
    return  LPTagController;
});

